import { render, staticRenderFns } from "./PropertyCatgeory.vue?vue&type=template&id=06c0feae&"
import script from "./PropertyCatgeory.vue?vue&type=script&lang=js&"
export * from "./PropertyCatgeory.vue?vue&type=script&lang=js&"
import style0 from "./PropertyCatgeory.vue?vue&type=style&index=0&id=06c0feae&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports